/**
 * This returns the matching vue component in the parent hierarchy of passed element.
 * @param el
 * @param componentName
 * @returns {*|null}
 */
const getParentVueComponent = (el, componentName) => {
  if (!el) {
    return null
  } else if (el.__vue__ && el.__vue__.$options.name === componentName) {
    return el.__vue__
  } else {
    return getParentVueComponent(el.parentElement, componentName)
  }
}

export default getParentVueComponent
